import { Injectable } from '@angular/core';
import { NgbTimeAdapter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';

import { ISOTIME_FORMAT } from './date-format';
import { StringUtils } from './utils/string-utils';

@Injectable()
export class CustomNgbTimeAdapter extends NgbTimeAdapter<string> {
  fromModel(value: string | null): NgbTimeStruct | null {
    if (!value) {
      return null;
    }
    if (ISOTIME_FORMAT.test(value)) {
      return {
        hour: Number(value.substring(0, 2)),
        minute: Number(value.substring(3, 5)),
        second: Number(value.substring(6, 8)),
      };
    }
    console.warn('Invalid time', value);
    return null;
  }

  toModel(time: NgbTimeStruct | null): string | null {
    if (!time) {
      return null;
    }
    const hour = StringUtils.paddingZeroLeft(time.hour, 2);
    const minute = StringUtils.paddingZeroLeft(time.minute, 2);
    const second = StringUtils.paddingZeroLeft(time.second, 2);
    return `${hour}:${minute}:${second}`;
  }
}
